import { useContext } from "react";
import ScreenTextContext from "../contexts/ScreenTextContext";

// Displays the logo associated with the selected mode
export const ModeLogo = ({mode}) => {
    
    const { screenText } = useContext(ScreenTextContext);
    const { language } = screenText;

    return (
        <img 
            src={`${process.env.PUBLIC_URL}/assets/images/logos/${language}/logo-${mode}.png`} alt={`HAZWOPER Challenge, ${screenText.global.modes[mode].fullTitle}`} 
        />
    )
}